
import { useParams } from 'react-router-dom';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Card, CardContent } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
import './Learn.css';
const useStyles = makeStyles(theme => ({
    mainFeaturedPost: {
        position: 'relative',
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
        marginBottom: theme.spacing(4),
        marginTop: '11vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '250px',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,.3)',
    },
    mainFeaturedPostContent: {
        position: 'relative',
        padding: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(6),
            paddingRight: 0,
        },
        icon: {
            marginRight: theme.spacing(2),
        },
        heroContent: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(8, 0, 6),
        },
        heroButtons: {
            marginTop: theme.spacing(4),
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        card: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        cardMedia: {
            paddingTop: '56.25%', // 16:9
        },
        cardContent: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f5f5',
        },
        footer: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(6),
        },
    },
}));


function LearnMain() {
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const { learn_id } = useParams();
    const [learn, setLearn] = useState([]);
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learning/contentLearn`, { learn_id: learn_id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            setLearn(response.data);

        });

    }, []);

    return <Grid container spacing={4}>
        {learn.map((value, key) => (
            <Grid item key={key} xs={12} sm={5} className="gridStylingLearn">
                <Card className="card" onClick={(e) => {
                    history.push('/user/aprendizaje/' + learn_id + "/" + value.learn_id)
                }} >
                    <CardContent className="cardContentStylingLearn">

                        <img src={value.location} alt="learning" className="imgStylingLearn" />
                        <div>
                            <Typography gutterBottom variant="h5" component="h2" className="typographyStyling1">
                                {value.title}
                            </Typography>
                        </div>

                    </CardContent>
                    <div className="divStyling2Learn">
                        {value.level == "Fácil" ? <h5 className="colorGreen">{value.level}</h5> : value.level == "Intermedio" ? <h5 className="color2">{value.level}</h5> : <h5 className="colorRed">{value.level}</h5>}

                    </div>
                </Card>
            </Grid>
        ))}

    </Grid>
}
export default function Learn2(props) {
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const { learn_id } = useParams();
    const classes = useStyles();
    const history = useHistory();
    const [learnHead, setLearnHead] = useState([]);
    useEffect(() => {
        axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learning/contentLearnHead`, { learn_id: learn_id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response) {
                setLearnHead(response.data);

            }
        });

    }, []);
    return (
        <>
            <Paper className="mainFeaturedPost" >
                <div className="overlay" />
                <Grid container>
                    <Grid item md={6}>
                        <div className="mainFeaturedPostContent">
                            {learnHead.map((value) => {
                                return (
                                    <>
                                        <Typography component="h1" variant="h3" color="inherit" gutterBottom>
                                            {value.title}
                                        </Typography>
                                        <Typography variant="h5" color="inherit" paragraph>
                                            {value.description}
                                        </Typography>
                                    </>
                                )
                            })}

                        </div>
                    </Grid>
                </Grid>
            </Paper>
            <LearnMain />
        </>
    );
}
